import React, { useContext } from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/macro';
import { FormattedCurrency } from '@qover/react-intl';
import { roundUpCurrency } from '@qover/utils/src/tools';
// @ts-ignore
import { ThemeContext } from '@qover/styles';
import { Footnote, Sitemap, Heading4 } from '@qover/typography';

export const Footer = styled.div`
  border-top: 1px solid var(--color-text-quote-10);
  display: flex;
  flex: 1 1 auto;
  justify-content: space-between;
  padding-top: 20px;
`;

export const TotalPrice = styled.div`
  text-align: right;
`;

type SummaryTotalProps = {
  cashbackMessage?: React.ReactNode;
  discountFirstYearOnly?: boolean;
  paymentRythmMessage: React.ReactNode;
  recurringDiscount?: boolean;
  secondaryPrice?: number;
  totalPrice: number;
};

export function SummaryTotal(props: SummaryTotalProps) {
  const theme = useContext<any>(ThemeContext);
  const asterisk = props.recurringDiscount === false ? '*' : null;

  return (
    <Footer>
      <Heading4 as="div">
        <strong>
          <Trans id="general.cart.total" />
        </strong>
      </Heading4>
      <TotalPrice>
        <Heading4
          as="div"
          data-test="general.summaryCard.total.price"
          style={{
            alignItems: 'baseline',
            color: !!props.secondaryPrice
              ? 'var(--color-primary-100)'
              : 'var(--color-text-quote-100)',
            display: 'flex',
          }}
        >
          {!!props.secondaryPrice && (
            <div
              style={{
                color: 'var(--color-text-quote-100)',
                marginRight: '10px',
                textDecoration: 'line-through',
              }}
            >
              <Sitemap
                as="div"
                className="bold"
                data-test="general.summaryCard.total.subprice"
              >
                <FormattedCurrency
                  value={roundUpCurrency(props.secondaryPrice)}
                />
                {props.paymentRythmMessage}
                {asterisk}
              </Sitemap>
            </div>
          )}
          <div>
            <FormattedCurrency value={props.totalPrice} />
            <Footnote> {props.paymentRythmMessage}</Footnote>
          </div>
          {asterisk}
        </Heading4>
        {asterisk && (
          <div style={{ marginTop: '5px' }}>
            <Sitemap as="div" data-test="general.summaryCard.total.subprice">
              <Trans id="general.discountFirstYearOnlyMessage" />
            </Sitemap>
          </div>
        )}
        {theme?.featureToggles?.cashback && props.cashbackMessage && (
          <div style={{ marginTop: '5px' }}>
            <Sitemap
              as="div"
              className="color-primary font-bold"
              data-test="general.summaryCard.total.cashback"
            >
              {props.cashbackMessage}
            </Sitemap>
          </div>
        )}
      </TotalPrice>
    </Footer>
  );
}
